<div class="filter-item">
  <mat-form-field class="full-width" subscriptSizing="dynamic">
    <mat-label>{{placeholder | translate}}</mat-label>
    <input matInput type="text" [formControl]="valueControl" />
    @if (valueControl.invalid) {
      <mat-error>{{invalidText | translate}}</mat-error>
    }
  </mat-form-field>
</div>